import React, { useContext } from "react";
import SearchBox from "../Common/Components/SearchBox.jsx";
import Pagination from "../Common/Components/Pagination.jsx";
import RankingTooltipsTriggerContainer from "../RankingTooltips/RankingTooltipsTriggerContainer";
import RankingTableContainer from "./RankingTableContainer";
import MobileClassifications from  "../Core/Mobile/Classifications";
import { FormattedMessage, injectIntl } from "react-intl";
import { FormattedMoneyHideZero } from "../utils/FormattedMoneyHideZero";
import { IsMobileContext } from "../isMobileContext";
import GameDetails from 'zweeler-game-details';


const GameDetailsTrigger = ({onClick, title}) => (
  <a
      className='result-game-detail-trigger'
      onClick={onClick}>
        {title}
  </a>
);

const RankingPanel = ({
  noEntries,
  page,
  pagesTotal,
  onPageClick,
  classification,
  onSearch,
  search,
  game,
  intl
}) => {

  const ctx = useContext(IsMobileContext);

  if (!classification) {
    return null;
  }

  if (noEntries) {
    return (
      <Panel name={`${game.name} ${classification.name}`}>
        <div className="alert alert-info">
          <FormattedMessage id="ranking.noEntries" />
          {search ? (
            <div>
              <FormattedMessage id="ranking.searchAgain" />:
              <SearchBox
                defaultValue={search}
                key={search}
                onSearch={value => onSearch(classification, value)}
              />
            </div>
          ) : null}
        </div>
      </Panel>
    );
  }

  return (
    <section className="ranking-table module">
      <header className="ranking-module__header">
        <div className="ranking-table__additional-info">
          {
            ctx.isMobile ? <GameDetails gameId={game.id} render={(onClick) => (<GameDetailsTrigger title={intl.formatMessage({ id: "game-details" })} onClick={onClick} />)} />  : <span className="ranking-table__name">{`${classification.name}`}</span> }
        {/* <span className="ranking-table__name">{`${classification.name}`}</span> */}
          {renderPrizes(game)}
        </div>
        {ctx.isMobile ? <MobileClassifications /> : null}
        <div className="ranking-table__actions">
          <div className="ranking-table__info-btn">
            <RankingTooltipsTriggerContainer />
          </div>

          <FormattedMessage id="ranking.searchPlaceholder">
            {message => (
              <SearchBox
                className="ranking-table__search"
                defaultValue={search}
                onSearch={value => onSearch(classification, value)}
                placeholder={message}
              />
            )}
          </FormattedMessage>

          <Pagination
            page={page}
            pagesTotal={pagesTotal}
            pagesCap={7}
            onClick={pageIndex =>
              onPageClick(classification, pageIndex, search)
            }
            className="ranking-table__pagination"
          />
        </div>
      </header>
      <RankingTableContainer classificationId={classification.id} />
    </section>
  );
};

const renderPrizes = function(game) {
  if (Number(game.prizes.total.amount) === 0) {
    return null;
  }

  return (
    <span className="ranking-table__name">
      <span className="ranking-table__prize-pool-heading">
        <FormattedMessage id={"ranking.prizePool"} />
        {`: `}
      </span>
      <span className="ranking-table__prize-pool">
        <FormattedMoneyHideZero {...game.prizes.total} />
      </span>
    </span>
  );
};

const Panel = ({ name, children }) => (
  <section className="module">
    <header className="module__header">
      <h2 className="module__title">{name}</h2>
    </header>
    {children}
  </section>
);

RankingPanel.propTypes = {};

export default injectIntl(RankingPanel);
